import React from 'react'
import { Table,  Space } from 'antd'
function ArapAdd() {
    const columns = [
        {
            title: '单据类型',
            dataIndex: 'wl_dj_type_name',
            width: '12%',
            key: 'wl_dj_type_name',
        },
        
        {
            title: '客户',
            dataIndex: 'wl_kh_name',
            width: '5%',
            key: 'wl_kh_name',
        },
        {
            title: '金额',
            dataIndex: 'wl_dj_price',
            width: '5%',
            key: 'wl_dj_price',
            render: (text, record) => {
                return <span>￥{text}</span>
            }
        },
        {
            title: '备注',
            dataIndex: 'wl_dj_content',
            width: '5%',
            key: 'wl_dj_content',
        },
        {
            title: '单据编号',
            dataIndex: 'wl_dj_id',
            width: '5%',
            key: 'wl_dj_id',
        },
        {
            title: '操作',
            dataIndex: 'wl_dj_action',
            width: '5%',
            key: 'wl_dj_action',
            render: (text, record) => {
                return <Space>
                    <a onClick={() => {}}>应收</a>
                    <a onClick={() => {}}>已收</a>
                    <a onClick={() => {}}>现收</a>
                </Space>
            }
        }
    ]
    const data = [
        {
            key: '1',
            wl_dj_type_name: '收款单',
            wl_kh_name: '客户1',
            wl_dj_price: 100,
            wl_dj_content: '备注1',
            wl_dj_id: '1234567890',
            wl_dj_action: '新增',
        }
    ]
    return (
        <>
            <Table
                columns={columns}
                dataSource={data}
                bordered
                size='small'
                rowKey='key'
                className="custom-table"

            />
        </>
    )
}

export default ArapAdd